import { type Hash } from 'history';
import { matchPath } from 'react-router';

import parseHashSearchParam from '../parseHashSearchParam';

const changePasswordMatcher = (hash: Hash) => {
  const path = hash.substring(1);
  const [pathname, search] = path.split('?');
  const match = matchPath('/change-password/:userId/:token', pathname);
  if (!match) {
    return null;
  }
  return {
    ...match.params,
    email: parseHashSearchParam(search, 'email'),
  };
};

export default changePasswordMatcher;
